module.exports = __webpack_public_path__ + "static/media/exampleProfile.b611f5b5.jpg";